import {useEffect, useState} from "react";
import Step from "./Step";
import TransactionsTable from "../TransactionsTable";

export default function AboutPayees({onNext, index}) {
  const [transaction, setTransaction] = useState(null);

  useEffect(() => {
    fetch("/api/on_ramp/example_data")
      .then(response => response.json())
      .then(data => {
        setTransaction(data.transactions.categorized);
      });
  }, []);

  if(!transaction) return "";
  return <Step index={index} title="About Payees" onNext={onNext} canProceed>
    <p>
      Every Transaction moves money. Most of the time that money is moved to another
      person or company. In Prosperity, we call those people and companies <strong>"Payees"</strong>.
      Each Payee has a <strong>name</strong> and a <strong>category</strong>. Here's an example
      transaction that we have categorized:
    </p>
    <TransactionsTable transactions={[transaction]} columns={["payee_name", "category"]} />
    <p>
      Once we have categorized a transaction into a Payee, we use AI to guess at what
      other transactions have similar descriptions and categorize them the same way.
      Each payee has a Match Expression that we use to match other transactions.
    </p>
  </Step>
}